/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PutOfferAttributesOut
 */
export interface PutOfferAttributesOut {
    /**
     * 
     * @type {string}
     * @memberof PutOfferAttributesOut
     */
    valueInterpretationStatusCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PutOfferAttributesOut
     */
    valueInterpretationMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof PutOfferAttributesOut
     */
    valueOriginal?: string;
    /**
     * 
     * @type {string}
     * @memberof PutOfferAttributesOut
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof PutOfferAttributesOut
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PutOfferAttributesOut
     */
    dataTypeCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof PutOfferAttributesOut
     */
    isVisible?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PutOfferAttributesOut
     */
    modificationDate: Date;
    /**
     * 
     * @type {number}
     * @memberof PutOfferAttributesOut
     */
    attributeId: number;
}

export function PutOfferAttributesOutFromJSON(json: any): PutOfferAttributesOut {
    return PutOfferAttributesOutFromJSONTyped(json, false);
}

export function PutOfferAttributesOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutOfferAttributesOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'valueInterpretationStatusCode': !exists(json, 'valueInterpretationStatusCode') ? undefined : json['valueInterpretationStatusCode'],
        'valueInterpretationMessage': !exists(json, 'valueInterpretationMessage') ? undefined : json['valueInterpretationMessage'],
        'valueOriginal': !exists(json, 'valueOriginal') ? undefined : json['valueOriginal'],
        'code': json['code'],
        'name': json['name'],
        'dataTypeCode': json['dataTypeCode'],
        'isVisible': !exists(json, 'isVisible') ? undefined : json['isVisible'],
        'modificationDate': (new Date(json['modificationDate'])),
        'attributeId': json['attributeId'],
    };
}

export function PutOfferAttributesOutToJSON(value?: PutOfferAttributesOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'valueInterpretationStatusCode': value.valueInterpretationStatusCode,
        'valueInterpretationMessage': value.valueInterpretationMessage,
        'valueOriginal': value.valueOriginal,
        'code': value.code,
        'name': value.name,
        'dataTypeCode': value.dataTypeCode,
        'isVisible': value.isVisible,
        'modificationDate': (value.modificationDate.toISOString()),
        'attributeId': value.attributeId,
    };
}


